const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
  e.preventDefault();
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
};

export default function ScrollToTopButton() {
  return (
    <a
      className="opacity-60 fixed bottom-[3%] right-[4%] z-20 flex aspect-square w-8 items-center justify-center rounded-full bg-gray transition duration-300 hover:scale-125 hover:opacity-100"
      onClick={handleClick}
    >
      <img src="/res/svgs/downArrow.svg" className="w-8/12 rotate-180 " />
    </a>
  )
}
